export default __webpack_public_path__ + "static/media/mamut_background_m2.5e80a82f.jpg";